export default {"src":"/_next/static/media/ArticleFillIcon.491dcf73.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};